import { createSlice } from "@reduxjs/toolkit";
import {
  fetchJournalRecord,
  fetchAccountsBySearch,
} from "./journalRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accounts: [],
  accountsLoading: [],
  filters: {
    filterType: "All",
    recordType: "without details",
    accountId: null,
    userId: null,
    fromDate: null,
    toDate: null,
  },
};

const journalRecordSlice = createSlice({
  name: "journalRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
    resetFilters: (state) => {
      state.filters = initialState.filters; // restore defaults
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJournalRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJournalRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchJournalRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchAccountsBySearch.pending, (state) => {
        state.accountsLoading = true;
      })
      .addCase(fetchAccountsBySearch.fulfilled, (state, action) => {
        state.accountsLoading = false;
        state.accounts = action.payload;
      })
      .addCase(fetchAccountsBySearch.rejected, (state) => {
        state.accountsLoading = false;
        state.accounts = [];
      });
  },
});

export const { setFilters } = journalRecordSlice.actions;
export default journalRecordSlice.reducer;
